var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.953691 44.2493L0.82176 44.1247C0.305052 43.5851 0 42.7472 0 41.6623V41.9176V3.15882C0 3.15531 0 3.15268 0 3.14988C0 3.15321 0 3.15601 0 3.15952V3.41556C0 2.24067 0.355657 1.35565 0.951559 0.824986L22.9513 22.5379L0.953691 44.2493ZM0 3.14778C0 3.05121 0.00266331 2.95745 0.00763508 2.8651C0.00266331 2.95675 0 3.05121 0 3.14778ZM0.00763508 2.86089C0.00763508 2.85967 0.00763343 2.85826 0.00816612 2.85686C0.00763343 2.85826 0.00763508 2.85967 0.00763508 2.86089ZM0.00816612 2.84862C0.00816612 2.84792 0.00816612 2.84722 0.00816612 2.84652C0.00816612 2.84722 0.00816612 2.84792 0.00816612 2.84862Z",
    fill: "url(#paint0_linear_2094_70)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2835 30.0346L30.4508 29.9408L39.1388 25.0687C39.9671 24.6039 40.5191 24.0405 40.7945 23.4442C40.5198 24.0405 39.9676 24.6046 39.1388 25.0694L30.4508 29.9415L30.2835 30.0346V30.0346ZM30.2857 29.7779L22.9514 22.5378L30.2849 15.299L39.1388 20.2636C40.2631 20.8942 40.8943 21.7068 40.9998 22.5371C40.9998 22.5378 40.9998 22.5392 40.9998 22.5405C40.8943 23.3689 40.2631 24.1822 39.1388 24.8126L30.2857 29.7779",
    fill: "url(#paint1_linear_2094_70)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52205 45.0762C1.9075 45.0762 1.37126 44.879 0.9531 44.5066L0.953813 44.5059C1.37197 44.8783 1.90892 45.0762 2.52347 45.0762C2.57674 45.0762 2.63089 45.0748 2.68576 45.0721C2.63018 45.0748 2.57532 45.0762 2.52205 45.0762V45.0762ZM2.52276 44.8194C1.90821 44.8201 1.37197 44.6223 0.953813 44.2499V44.2493L22.9514 22.5378L30.2856 29.7779L4.51199 44.2315C3.7989 44.6305 3.12328 44.8194 2.52276 44.8194V44.8194ZM0.947598 44.5019C0.908711 44.467 0.870535 44.43 0.833069 44.3916L0.947598 44.5019Z",
    fill: "url(#paint2_linear_2094_70)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9513 22.5378L0.951599 0.824981C1.36976 0.453271 1.90529 0.256112 2.51913 0.256112C3.12124 0.256112 3.7974 0.445736 4.51191 0.845486L30.2848 15.2991L22.9513 22.5378V22.5378ZM30.4507 15.1355L4.51191 0.589614C3.7974 0.189689 3.12124 6.92845e-05 2.51913 6.92845e-05C2.51628 6.92845e-05 2.51433 6.92845e-05 2.51149 6.92845e-05C2.51504 6.92845e-05 2.5177 6.92845e-05 2.52197 6.92845e-05C3.12266 6.92845e-05 3.79811 0.188989 4.51191 0.588914L30.4507 15.1355V15.1355Z",
    fill: "url(#paint3_linear_2094_70)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68547 45.0721C3.24373 45.0406 3.86183 44.851 4.51171 44.4875L30.2832 30.0346L4.51171 44.4875C3.86236 44.8517 3.24373 45.0406 2.68547 45.0721V45.0721ZM0.952813 44.5066L0.94731 44.5019C0.949263 44.5033 0.951392 44.5052 0.952813 44.5066ZM0.832781 44.3916L0.821594 44.3808V44.3801C0.825856 44.3841 0.82923 44.3881 0.832781 44.3916Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2837 30.0346L30.4497 29.9408L30.2837 30.0346Z",
    fill: "url(#paint4_linear_2094_70)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52318 45.0762C1.90864 45.0762 1.37169 44.8783 0.953526 44.5059L0.952813 44.5066C0.951392 44.5052 0.949263 44.5033 0.94731 44.5019L0.832781 44.3916C0.82923 44.3881 0.825856 44.3841 0.821594 44.3801L0.953526 44.2499C1.37169 44.6223 1.90793 44.8201 2.52247 44.8194C3.12299 44.8194 3.79861 44.6305 4.51171 44.2315L30.2853 29.7779L30.4505 29.9409L30.2832 30.0346L4.51171 44.4875C3.86183 44.851 3.24373 45.0406 2.68547 45.0721C2.63061 45.0748 2.57645 45.0762 2.52318 45.0762",
    fill: "url(#paint5_linear_2094_70)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.821765 44.3807C0.305053 43.8411 0 43.0033 0 41.9183V41.9176C0 43.0033 0.305053 43.8404 0.821765 44.38V44.3807",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.821759 44.3801C0.305051 43.8405 0 43.0033 0 41.9176V41.6623C0 42.7472 0.305051 43.5851 0.821759 44.1247L0.953691 44.2493L0.821759 44.3801",
    fill: "url(#paint6_linear_2094_70)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.821594 44.3801L0.952563 44.2493V44.2498L0.821594 44.3801",
    fill: "url(#paint7_linear_2094_70)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7944 23.4442C40.93 23.1483 40.9982 22.8444 40.9982 22.5404C40.9982 22.5398 40.9982 22.5391 40.9982 22.5391C40.9982 22.8437 40.93 23.1476 40.7944 23.4442Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4508 29.9408L30.2856 29.7778L39.1388 24.8126C40.2631 24.1822 40.8943 23.3688 40.9998 22.5404C40.9998 22.8445 40.9311 23.1484 40.7945 23.4442C40.5191 24.0404 39.9671 24.6038 39.1388 25.0686L30.4508 29.9408Z",
    fill: "url(#paint8_linear_2094_70)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9998 22.5378V22.5371C40.9991 21.6204 40.3783 20.7038 39.1388 20.0083L30.4508 15.1361H30.4501L30.4508 15.1355L39.1388 20.0076C40.3798 20.7031 41.0012 21.6211 40.9998 22.5378Z",
    fill: "#404040"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41 22.5371C40.8945 21.7068 40.2633 20.8941 39.139 20.2636L30.2852 15.299L30.4503 15.136H30.451L39.139 20.0082C40.3785 20.7038 40.9993 21.6204 41 22.5371Z",
    fill: "url(#paint9_linear_2094_70)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.14984C0 3.14914 0 3.14844 0 3.14774C0 3.14844 0 3.14914 0 3.14984ZM0.00763508 2.86506C0.00763508 2.86365 0.00763508 2.86225 0.00763508 2.86085C0.00763508 2.86225 0.00763508 2.86365 0.00763508 2.86506ZM0.00816612 2.85682C0.00816612 2.85402 0.00816612 2.85139 0.00816612 2.84858C0.00816612 2.85139 0.00816612 2.85402 0.00816612 2.85682ZM0.00816612 2.84648C0.110975 1.04612 1.10284 0.00616825 2.50594 3.44184e-05C1.89761 0.00353946 1.36777 0.200698 0.952978 0.569604V0.568904L0.948007 0.573808C0.904326 0.612714 0.862777 0.653899 0.82176 0.69631C0.355657 1.18299 0.0616126 1.91204 0.00816612 2.84648Z",
    fill: "#404040"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.41559V3.15955C0 3.15604 0 3.15324 0 3.14991C0 3.14921 0 3.14851 0 3.14781C0 3.05124 0.00266332 2.95678 0.0076351 2.86512C0.0076351 2.86372 0.0076351 2.86232 0.0076351 2.86092C0.0076351 2.85969 0.00763345 2.85829 0.00816614 2.85689C0.00816614 2.85408 0.00816614 2.85145 0.00816614 2.84865C0.00816614 2.84795 0.00816614 2.84725 0.00816614 2.84655C0.0616128 1.9121 0.355658 1.18305 0.821762 0.696375L0.951562 0.825012C0.355659 1.35568 0 2.2407 0 3.41559V3.41559ZM0.94801 0.573873L0.952981 0.568969C0.951561 0.571072 0.94943 0.572471 0.94801 0.573873Z",
    fill: "url(#paint10_linear_2094_70)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2846 15.2991L4.51171 0.845554C3.79719 0.445804 3.12104 0.25618 2.51892 0.25618C1.90508 0.25618 1.36955 0.453339 0.951393 0.825049L0.821594 0.696412C0.862611 0.654001 0.904161 0.612816 0.947841 0.57391C0.949262 0.572508 0.951392 0.571108 0.952813 0.569706C1.3676 0.2008 1.89745 0.0036416 2.50578 0.000136557C2.5072 0.000136557 2.50915 0.000136557 2.51128 0.000136557C2.51413 0.000136557 2.51608 0.000136557 2.51892 0.000136557C3.12104 0.000136557 3.79719 0.189757 4.51171 0.589682L30.4505 15.1356L30.4497 15.1361L30.2846 15.2991Z",
    fill: "url(#paint11_linear_2094_70)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2094_70",
    x1: 21.0006,
    y1: 2.74995,
    x2: -8.40863,
    y2: 32.5469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2094_70",
    x1: 42.3697,
    y1: 22.5389,
    x2: -0.595206,
    y2: 22.5389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2094_70",
    x1: 26.3759,
    y1: 26.5604,
    x2: -13.5052,
    y2: 66.9673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2094_70",
    x1: -4.75048,
    y1: -12.2052,
    x2: 13.058,
    y2: 5.8381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2094_70",
    x1: 42.2818,
    y1: 22.5386,
    x2: -0.369951,
    y2: 22.5386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2094_70",
    x1: 26.3756,
    y1: 26.5604,
    x2: -13.5055,
    y2: 66.9673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2094_70",
    x1: 21.0005,
    y1: 2.74993,
    x2: -8.40865,
    y2: 32.5469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2094_70",
    x1: 26.1895,
    y1: 26.5599,
    x2: -13.6953,
    y2: 66.6754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2094_70",
    x1: 42.3697,
    y1: 22.5388,
    x2: -0.595217,
    y2: 22.5388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2094_70",
    x1: 42.3699,
    y1: 22.5389,
    x2: -0.594972,
    y2: 22.5389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2094_70",
    x1: 21.0006,
    y1: 2.74998,
    x2: -8.40858,
    y2: 32.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2094_70",
    x1: -4.75069,
    y1: -12.2051,
    x2: 13.0578,
    y2: 5.83815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLogo);
export default __webpack_public_path__ + "static/media/googlePlayLogo.36f17d06bf821d6439eeb21b0bdaa579.svg";
export { ForwardRef as ReactComponent };